import { useQuery } from '@tanstack/react-query';
import { Building } from 'lucide-react';
import { shortRupees } from '#shared';
import { api } from '../../lib/api';
import { formatDate } from '../../lib/format';
import type { Unit } from '../../pages/tenant/Inventory';
import { unitSummary } from '../../pages/tenant/Inventory';
import { ButtonLink } from '../ui';

/** Flats / plots held for or sold to this lead. Nothing is shown when there are none. */
export function LeadUnits({ leadId }: { leadId: string }) {
  const units = useQuery({ queryKey: ['lead-units', leadId], queryFn: () => api.get<Unit[]>(`/leads/${leadId}/units`) });
  if (!units.data?.length) return null;
  return (
    <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800">
      <p className="flex items-center gap-2 border-b border-slate-200 px-4 py-2.5 text-sm font-medium dark:border-slate-800"><Building className="size-4 text-slate-400" />Units</p>
      <ul className="divide-y divide-slate-100 dark:divide-slate-800">
        {units.data.map((u) => (
          <li key={u.id} className="flex items-center gap-3 px-4 py-2.5 text-sm">
            <div className="min-w-0 flex-1">
              <p className="font-medium">{u.code} · {u.project}</p>
              <p className="truncate text-slate-500">{unitSummary(u)}</p>
            </div>
            <div className="text-right">
              <p className="font-medium">{shortRupees(u.price)}</p>
              <p className={u.status === 'sold' ? 'text-indigo-600' : 'text-amber-600'}>{u.status === 'sold' ? `Sold ${formatDate(u.soldAt)}` : `On hold till ${formatDate(u.blockedUntil)}`}</p>
            </div>
          </li>
        ))}
      </ul>
      <div className="px-4 py-2"><ButtonLink to="/inventory" variant="ghost" size="sm">Open inventory</ButtonLink></div>
    </div>
  );
}
